import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteAvatarResponseType } from '../types';

export const deleteAvatar = async () => {
  const url = '/api/v2/auth/user/avatar';

  const { data } = await apiAuthClient.delete<DeleteAvatarResponseType>(url);

  return data;
};
